'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService, $http) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.tableIdentifiers = { key: false, id: false };
    let appList = document.getElementsByClassName("applicationResults");
    let input = document.getElementsByClassName("iocRuleInput");

    let obj = {rule:"",type:""};

    if ($stateParams.include) {
        switch ($stateParams.include[0].column) {
            case 'resp_ip':
            case 'orig_ip':
            case 'ip':
                obj.type = "IPType";
                break;
            case 'filename':
            case 'file_name':
            case 'file':
                obj.type = "FileType";
                break;
            case 'md5':
            case 'sha1':
            case 'sha256':
                obj.type = "HashType";
                break;
            case 'top_domain':
            case 'domain':
            case 'host':
            case 'subdomain':
                obj.type = "HTTPType";
                break;
            default:
                obj.type = '';
            break;
        }
        obj.rule = $stateParams.include[0].value;
    }

    model.formFields = angular.copy({
        ioc_alert: 1,
        active_defense: 1,
        ioc_severity: "1",
        ioc_attribute: [obj],
        zone: "N/A",
    })

    let appIndex = -1;

    model.appNotEqual = false;

    let keys = {
        up: 38,
        down: 40,
        left: 37,
        right: 39,
        esc: 27,
        back: 8,
        enter: 13
    }

    model.applications = [
        'AFP',
        'Aimini',
        'Amazon',
        'Apple',
        'AppleiCloud',
        'AppleiTunes',
        'AppleJuice',
        'Armagetron',
        'AVI',
        'Ayiya',
        'BattleField',
        'BGP',
        'BitTorrent',
        'CiscoSkinny',
        'CiscoVPN',
        'Citrix',
        'Citrix_Online',
        'CNN',
        'Collectd',
        'Corba',
        'Crossfire',
        'DCE_RPC',
        'DHCP',
        'DHCPV6',
        'Direct_Download_Link',
        'DirectConnect',
        'DNS',
        'Dofus',
        'DropBox',
        'eBay',
        'eDonkey',
        'EGP',
        'EPP',
        'Facebook',
        'FacebookChat',
        'FastTrack',
        'Fiesta',
        'Filetopia',
        'Flash',
        'Florensia',
        'FTP_CONTROL',
        'FTP_DATA',
        'GMail',
        'Gnutella',
        'Google',
        'GoogleMaps',
        'GRE',
        'GrooveShark',
        'GTP',
        'Guildwars',
        'H323',
        'HalfLife2',
        'HTTP',
        'HTTP_Application_ActiveSync',
        'HTTP_APPLICATION_VEOHTV',
        'HTTP_Connect',
        'HTTP_Proxy',
        'IAX',
        'IceCast',
        'ICMP',
        'ICMPV6',
        'IGMP',
        'IMAP',
        'IMAPS',
        'iMESH',
        'IP_in_IP',
        'IPP',
        'IPsec',
        'IRC',
        'Kerberos',
        'Kontiki',
        'LastFM',
        'LDAP',
        'LLMNR',
        'LotusNotes',
        'MapleStory',
        'MDNS',
        'Meebo',
        'Megaco',
        'MGCP',
        'MMS',
        'Move',
        'MPEG',
        'MSN',
        'MsSQL',
        'MySQL',
        'NetBIOS',
        'NetFlix',
        'NetFlow',
        'NFS',
        'NOE',
        'NTP',
        'OggVorbis',
        'OpenFT',
        'OpenVPN',
        'Oracle',
        'Oscar',
        'OSPF',
        'Pando_Media_Booster',
        'PcAnywhere',
        'POP3',
        'POPS',
        'PostgreSQL',
        'PPLive',
        'PPStream',
        'PPTP',
        'QQ',
        'QQLive',
        'Quake',
        'QuickTime',
        'Radius',
        'RDP',
        'RealMedia',
        'Redis',
        'RemoteScan',
        'RSYNC',
        'RTCP',
        'RTMP',
        'RTP',
        'RTSP',
        'SAP',
        'SCTP',
        'sFlow',
        'ShoutCast',
        'SIP',
        'SkyFile_PostPaid',
        'SkyFile_PrePaid',
        'SkyFile_Rudics',
        'Skype',
        'SMB',
        'SMTP',
        'SMTPS',
        'SNMP',
        'SOCKS4',
        'SOCKS5',
        'Socrates',
        'Sopcast',
        'Soulseek',
        'Spotify',
        'SSDP',
        'SSH',
        'SSL',
        'SSL_No_Cert',
        'Stealthnet',
        'Steam',
        'STUN',
        'Syslog',
        'TDS',
        'TeamSpeak',
        'TeamViewer',
        'Telegram',
        'Telnet',
        'TFTP',
        'Thunder',
        'TOR',
        'TruPhone',
        'Tuenti',
        'Tvants',
        'TVUplayer',
        'Twitter',
        'UbuntuONE',
        'Unencryped_Jabber',
        'Unknown',
        'UPnP',
        'Usenet',
        'VHUA',
        'Viber',
        'VMware',
        'VNC',
        'VRRP',
        'Warcraft3',
        'Webex',
        'WebM',
        'WhatsApp',
        'Whois-DAS',
        'Wikipedia',
        'WindowsMedia',
        'WindowsUpdate',
        'WinMX',
        'WorldOfKungFu',
        'WorldOfWarcraft',
        'Xbox',
        'XDMCP',
        'Yahoo',
        'YouTube',
        'Zattoo',
        'ZeroMQ'
    ];
    model.filteredApps = {};
    model.applications.sort();

    model.checkApps = function (index, type) {
        for (let i = 0; i < appList.length; i++) {
            appList[i].className = "applicationResults term-list hidden";
        }

        model.filteredApps[index] = model.applications.filter(function (d) {
            if (model.formFields.ioc_attribute[index].rule) {
                if (d.toLowerCase().indexOf(model.formFields.ioc_attribute[index].rule.toLowerCase()) > -1) {
                    return d
                }
            }
        })
        if (model.formFields.ioc_attribute[index].type === "l7proto") {
            if ((model.filteredApps[index].length === 1) && (model.filteredApps[index][0].toLowerCase() === model.formFields.ioc_attribute[index].rule.toLowerCase())) {
                model.formFields.ioc_attribute[index].rule = model.filteredApps[index][0];
                appList[index].className = "applicationResults term-list hidden";
            } else if (model.filteredApps[index].length > 0) {
                appList[index].className = "applicationResults term-list";
            } else {
                appList[index].className = "applicationResults term-list hidden";
            }

            input[index].onkeydown = function (e) {
                if (appList[index]) {
                    let list = appList[index].querySelectorAll('.customIocApp');
                    e = e || window.event;
                    let charcode = (typeof e.which == "number") ? e.which : e.keyCode;
                    if (charcode === keys.down) {
                        if (appIndex < model.filteredApps[index].length-1) {
                            if (appList[index].className.indexOf("hidden") === -1) {
                                appIndex++;
                            } else {
                                appList[index].className = "applicationResults term-list";
                            }
                        }
                    } else if (charcode === keys.up) {
                        if (appIndex > 0) {
                            if (appList[index].className.indexOf("hidden") === -1) {
                                appIndex--;
                            }
                        }
                    } else if (charcode === keys.esc) {
                        appList[index].className = "applicationResults term-list hidden";
                        appIndex = -1;
                    } else if (charcode === keys.back) {
                        appIndex = 0;
                    } else if (charcode === keys.enter) {
                        if (appIndex > -1) {
                            $scope.$apply(function () {
                                model.formFields.ioc_attribute[index].rule = list[appIndex].innerHTML;
                            })
                            appList[index].className = "applicationResults term-list hidden";
                            appIndex = -1;
                        }
                    }
                    for (let i = 0, len = list.length; i < len; i++) {
                        list[i].className = "customIocApp";
                    }
                    if ((list.length > appIndex) && (appIndex > -1)) {
                        list[appIndex].className = "customIocApp customIocAppSelect";
                    }
                }
            }
        } else {
            appList[index].className = "applicationResults term-list hidden";
        }
    }
    window.onkeydown = function (e) {
        e = e || window.event;
        let charcode = (typeof e.which == "number") ? e.which : e.keyCode;
        if (charcode === keys.enter) {
            e.preventDefault();
        }
    }

    model.setRule = function (index, value) {
        model.formFields.ioc_attribute[index].rule = value;
        for (let i = 0; i < appList.length; i++) {
            appList[i].className = "applicationResults term-list hidden";
        }
        model.filteredApps = {};
    }

    // inital setup of form variable
    model.setForm = function (form) {
        model.formFields = model.formFields;
    }

    model.addAttribute = function () {
        if (model.formFields.ioc_attribute.length < 11) {
            model.formFields.ioc_attribute.push({rule:"",type:"IPType"})
        }
    }

    model.removeAttribute = function (index) {
        if (model.formFields.ioc_attribute.length > 1) {
            model.formFields.ioc_attribute.splice(index, 1)
        }
    }

    model.handleInsert = function (data) {
        model.appNotEqual = true;
        model.hasL7 = false;
        for (let i = 0, len = data.ioc_attribute.length; i < len; i++) {
            if (data.ioc_attribute[i].type === "l7proto") {
                model.hasL7 = true;
                model.appNotEqual = true;
                for (var j = 0, applen = model.applications.length; j < applen; j++) {
                    if (model.applications[j].toLowerCase() === data.ioc_attribute[i].rule.toLowerCase()) {
                        data.ioc_attribute[i].rule = model.applications[j];
                        model.appNotEqual = false;
                    }
                }
                if (model.appNotEqual) {
                    return;
                }
            }
        }
        if (model.hasL7) {
            if (!model.appNotEqual) {
                model.insert(data)
            }
        } else {
            model.insert(data)
        }
    }

    model.insert = function (data) {
        data.ioc_attribute = angular.copy(data.ioc_attribute);
        if (typeof data.ioc_attribute === "string") {
            data.ioc_attribute = JSON.parse(array[a].ioc_attribute);
        }
        data.custom_type = [];
        data.custom_rule = [];
        for (let i in data.ioc_attribute) {
            data.custom_type.push(data.ioc_attribute[i].type)
            data.custom_rule.push(data.ioc_attribute[i].rule)
        }
        data.ioc_attribute = JSON.stringify(data.ioc_attribute);
        let time = angular.copy($scope.main.getTime());
        data.email = $scope.global.user.email;
        data.time = Math.round(new Date().getTime() / 1000);
        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
        }
        // $scope.main.manualQuery(time, { call:'insert', params: angular.copy(data) });

        let newIOC = angular.copy(data);
        $http({
            method: 'POST',
            url: api+'/api/ioc_notifications/custom_ioc/insert',
            data : {
                id : newIOC.id,
                email : newIOC.email,
                ioc_class : newIOC.ioc_class,
                ioc_severity : newIOC.ioc_severity,
                ioc_alert : newIOC.ioc_alert,
                active_defense : newIOC.active_defense,
                ioc_attribute : newIOC.ioc_attribute,
                time : newIOC.time,
                zone : newIOC.zone
            }
        }).success(function (result) {
            result[0].custom_type = JSON.stringify(newIOC.custom_type);
            result[0].custom_rule = JSON.stringify(newIOC.custom_rule);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                $scope.main.buildDimGroup(result, model.tableIdentifiers).then(function () {
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                })
            }
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
                return (d.id == result[0].id);
            });
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result);
            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
        })

        model.formFields = angular.copy({
            ioc_alert: 1,
            active_defense: 1,
            ioc_severity: "1",
            ioc_attribute: [{rule:"",type:"IPType"}],
            zone: "N/A",
        })
        model.filteredApps = {}
        for (let i = 0; i < appList.length; i++) {
            appList[i].className = "applicationResults term-list hidden";
        }
        delete model.editMode;
        model.customIOCForm.$setPristine();
        model.setForm();
        model.appNotEqual = false;
        appList.className = "term-list hidden";
        appIndex = -1;
    }

    // DELETE ROW FROM TABLE
    model.deleteTarget = function (data) {
        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
        }
        $http({
            method: 'POST',
            url: api+'/api/ioc_notifications/custom_ioc/delete',
            data: {
                id : data.id,
            }
        }).success(function () {
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
                return (d.id == data.id);
            });
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
        })
    }

    model.editTarget = function (call, data) {
        if (data.ioc_alert !== 0) {
            data.ioc_alert = 1;
        }
        if (data.active_defense !== 0) {
            data.active_defense = 1;
        }
        if (typeof data.ioc_attribute === "string" ) {
            data.ioc_attribute = JSON.parse(data.ioc_attribute);
        }
        // ioc_attribute
        model.formFields = data;
        model.editMode = {
            call: call,
            id: data.id,
            value: true
        };
    }

    function convertRuleType(array) {
        for (let a in array) {
            if (typeof array[a].ioc_attribute === "string") {
                array[a].ioc_attribute = JSON.parse(array[a].ioc_attribute);
            }
            array[a].custom_type = [];
            array[a].custom_rule = [];
            for (let i in array[a].ioc_attribute) {
                array[a].custom_type.push(array[a].ioc_attribute[i].type)
                array[a].custom_rule.push(array[a].ioc_attribute[i].rule)
            }
        }
        return array;
    }

    socketIo('/api/ioc_notifications/custom_ioc').then(function (socket) {
        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['id'],
            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
            hideToggleBytes: true,
            title: 'Indicators of Compromise (IOC) Notifications',
            columns: [
                { title: 'Created', select: 'time', dView: true },
                { title: 'Created By', select: 'email', dView: true },
                { title: 'IOC Class', select: 'ioc_class', dView: true },
                { title: 'IOC Severity', select: 'ioc_severity', dView: true },
                { title: 'IOC Alert', select: 'ioc_alert', dView: true },
                { title: 'Active Defense', select: 'active_defense', dView: true },
                { title: 'IOC Type', select: 'custom_type', dView: true },
                { title: 'IOC Rule', select: 'custom_rule', dView: true },
                {
                    title: 'Delete',
                    select: "Delete",
                    dView: true,
                    link: {
                        type: 'Delete',
                        call: 'delete',
                    },
                },
                {
                    title: 'Edit',
                    select: 'Edit',
                    dView: true,
                    link: {
                        type: 'Edit',
                        call: 'insert',
                    },
                }
            ],
            searchCategories: {
                'email': 'Email',
                'ioc_class': 'IOC Class',
                'active_defense': 'Active Defense',
                'ioc_attribute' : 'IOC Attribute',
                'custom_type': 'IOC Type',
                'custom_rule': 'IOC Rule',
                'ioc_severity': 'IOC Severity',
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {

        }, function (result) {
            result.rows = convertRuleType(result.rows)
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error')
                    console.log(err)
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService', '$http'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/custom_ioc.js
 **/